import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Field from 'components/Field';
import styles from 'modules/Profile/components/FamilyAccess/FamilyAccess.module.scss';
import Button, { BUTTON_COLORS } from 'components/Button';
import { numberOnly } from 'utils/reduxForm/inputFilters';

const AddTaxpayer = ({ onClose, onSubmit }) => {
  const [value, setValue] = useState('');
  const [isLoading, setLoading] = useState(false);
  const [errorMessage, setError] = useState(null);

  const setInputValue = useCallback(
    ({ target: { value: newValue } }) => {
      setValue(numberOnly(newValue, value));
    },
    [value],
  );

  const onInnSubmit = useCallback(async () => {
    setLoading(true);
    const { error } = await onSubmit(value);

    if (error) {
      setError(get(error, 'response.data.message'));
      setLoading(false);
    }
  }, [onSubmit, value]);
  return (
    <div className={styles.addUser}>
      <h2>Добавить пользователя</h2>

      <div className={styles.text}>
        Отправляя запрос на добавление, Вы запрашиваете доступ на возможность просмотра и оплаты
        платёжных документов несовершеннолетнего ребенка в своем Личном кабинете налогоплательщика.
        Открытие доступа возможно после подтверждения такого запроса в Личном кабинете
        несовершеннолетнего ребенка.
      </div>

      <Field
        value={value}
        onChange={setInputValue}
        className={styles.input}
        isValid={!errorMessage}
        validationMessage={errorMessage}
        maxLength={12}
        isDisabled={isLoading}
        placeholder={'ИНН несовершеннолетнего пользователя'}
      />

      <div className={styles.actions}>
        <Button
          extraClassName={styles.button}
          color={BUTTON_COLORS.WHITE_BLUE}
          hasWrapper={false}
          onClick={onClose}
          isDisabled={isLoading}
        >
          Отменить
        </Button>
        <Button
          extraClassName={styles.button}
          color={BUTTON_COLORS.ORANGE}
          hasWrapper={false}
          onClick={onInnSubmit}
          isDisabled={isLoading}
        >
          Отправить запрос
        </Button>
      </div>
    </div>
  );
};

AddTaxpayer.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default AddTaxpayer;
